import React from 'react'
import Icon from 'components/Icon'
import styled from 'particles/themes/styled'

type Props = Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'children'> & {
    color?: string
    size?: string | number
    icon?: React.ReactElement
}

const CloseButton: React.FC<Props> = ({ size = 24, icon, ...props }) => {
    return (
        <button type="button" {...props}>
            {icon ? icon : <Icon.XIcon size={size} />}
        </button>
    )
}

export default styled(CloseButton)`
    padding: 0;
    ${props => (props.color ? `color: ${props.color};` : '')}
    height: ${props => (props.size ? (typeof props.size === 'number' ? `${props.size}px` : props.size) : '20px')};
    width: ${props => (props.size ? (typeof props.size === 'number' ? `${props.size}px` : props.size) : '20px')};
    background: none;
    border: none;
    cursor: pointer;
    line-height: 0;
`
